import React from "react";

function SearchInfo() {
  return <article>
    <h2>
      <span role="img" aria-label="coder">
        🍿
      </span>
      Search For Your Movie And I Will Change
      <span role="img" aria-label="coder">
        🍿
      </span>
    </h2>
  </article>
}

export default SearchInfo;
